import { MobileTimePicker } from "@mui/x-date-pickers/MobileTimePicker";

/**
 * CETimePicker — the CE-standard time picker.
 *
 * Renders the `MobileTimePicker` dialog (round clock face) UNCONDITIONALLY —
 * desktop and touch devices alike. Per Amine (2026-09-30): the mobile clock
 * is the Portal-wide standard; the Batch D desktop vertical-list delta was
 * reverted immediately.
 *
 * `alwaysMobile` is a deprecated no-op — kept accepted (and stripped from the
 * spread) so the existing call sites stay untouched.
 *
 * Every other prop is passed straight through to the underlying picker.
 *
 * @param {{ alwaysMobile?: boolean }} props
 */
const CETimePicker = ({ alwaysMobile = false, ...props }) => {
  return <MobileTimePicker {...props} />;
};

export default CETimePicker;
